var CursorStyle = /* @__PURE__ */ ((CursorStyle2) => {
  CursorStyle2["pointer"] = "pointer";
  CursorStyle2["notAllowed"] = "not-allowed";
  CursorStyle2["default"] = "default";
  return CursorStyle2;
})(CursorStyle || {});
export {
  CursorStyle
};
//# sourceMappingURL=cursor-style.es.js.map
